import { render, staticRenderFns } from "./OrgHomeInventoryCharts.vue?vue&type=template&id=4d3b3840&scoped=true&"
import script from "./OrgHomeInventoryCharts.vue?vue&type=script&lang=js&"
export * from "./OrgHomeInventoryCharts.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeInventoryCharts.vue?vue&type=style&index=0&id=4d3b3840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b3840",
  null
  
)

export default component.exports